<!--  -->
<template>
  <div>
    <div class="updata_label"><el-button type="success" icon="el-icon-refresh-left" @click="updata">刷新标签</el-button><el-button type="warning" icon="el-icon-plus" @click="addlabel">新建标签</el-button></div>
    <el-form label-position="right" label-width="20px">
      <el-form-item v-for="(item, topIndex) in cities" :key="topIndex" class="checkBox-item">
        <el-checkbox
          v-model="item.checked"
          class="textCheck"
          :indeterminate="item.indeterminate"
          @change="onChangeTop(topIndex, item.group_id, $event)"
        >{{ item.group_name }}</el-checkbox>
        <el-checkbox-group v-model="dialogCheckedCities">
          <el-checkbox
            v-for="city in item.children"
            :key="city.tag_id"
            v-model="city.checked"
            class="checkSon"
            :label="city.tag_id"
            @change="onChangeSon(topIndex, city.tag_id, item.group_id, $event)"
          >{{ city.tag_name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div><el-button type="primary" @click="sumbit">确定</el-button></div>
  </div>
</template>

<script>
import { corpTag } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      corp_id: '',
      cities: [],
      dialogCheckedCities: []
    }
  },
  created() {
    // this.taglist()
  },
  mounted() {

  },
  methods: {
    send(corp_id, arr) {
      this.corp_id = corp_id
      this.dialogCheckedCities = []
      this.dialogCheckedCities = arr
      this.taglist()
    },
    async taglist() {
      const data = await corpTag({
        corp_id: [this.corp_id]
      })
      for (let i = 0; i < data.data[0].children.length; i++) {
        // data.data[0].children[i].checkAll = false

        data.data[0].children[i].checked = false
        data.data[0].children[i].indeterminate = false
      }
      for (let u = 0; u < data.data.length; u++) {
        for (let f = 0; f < data.data[u].children.length; f++) {
          // console.log(res.data[u].children[f])
          for (let g = 0; g < data.data[u].children[f].children.length; g++) {
            // data.data[u].children[f].children[g].checkedCities = []
            console.log(data.data[u].children[f].children)

            data.data[u].children[f].children[g].checked = false
            data.data[u].children[f].children[g].indeterminate = false
            // console.log('data.data[u].children[f].children[g].tag_id', data.data[u].children[f].children[g].tag_id, this.dialogCheckedCities)
            this.dialogCheckedCities.forEach((item) => {
              // eslint-disable-next-line eqeqeq
              if (item == data.data[u].children[f].children[g].tag_id) {
                console.log('data.data[u].children[f].children[g].tag_id', data.data[u].children[f].children[g].tag_id)
                data.data[u].children[f].children[g].checked = true
                const flag = data.data[u].children[f].children.every(function(a) {
                  // eslint-disable-next-line eqeqeq
                  return a.checked == true
                })

                // eslint-disable-next-line eqeqeq
                if (flag == true) {
                  console.log('flag', flag)
                  data.data[u].children[f].checked = true
                }
              }
            })
          }
        }
      }

      this.cities = data.data[0].children

      console.log(data.data[0].children)
    },
    onChangeSonsdwr(topIndex, sonId, topId, e) {
      const that = this
      var childrenArray = that.cities[topIndex].children// 这里注意是选取一级下的二级数据
      var tickCount = 0
      var unTickCount = 0
      var len = childrenArray.length
      console.log(childrenArray)
      for (var i = 0; i < len; i++) {
        // if (sonId == childrenArray[i].tag_id) childrenArray[i].checked = e
        // eslint-disable-next-line eqeqeq
        if (childrenArray[i].checked == true) tickCount++
        // eslint-disable-next-line eqeqeq
        if (childrenArray[i].checked == false) unTickCount++
      }
      // eslint-disable-next-line eqeqeq
      if (tickCount == len) { // 子级全勾选
        that.cities[topIndex].checked = true
        that.cities[topIndex].indeterminate = false
      // eslint-disable-next-line eqeqeq
      } else if (unTickCount == len) { // 子级全不勾选
        that.cities[topIndex].checked = false
        that.cities[topIndex].indeterminate = false
      } else {
        that.cities[topIndex].checked = true
        that.cities[topIndex].indeterminate = true // 添加不确定状态
      }
    },
    onChangeTop(index, topId, e) { // 父级change事件
      const that = this
      that.cities[index].checked = e // 父级勾选后，子级全部勾选或者取消
      // eslint-disable-next-line eqeqeq
      if (e == false) that.cities[index].indeterminate = false // 去掉不确定状态
      var childrenArray = that.cities[index].children // 这里注意是选取一级下的二级数据
      var	len = childrenArray.length
      console.log('len', len)
      // eslint-disable-next-line eqeqeq
      if (that.cities[index].checked == true) {
        // 点击全选往v-model添加选中的id
        console.log('childrenArray[i]', childrenArray[i])
        for (var i = 0; i < childrenArray.length; i++) { that.dialogCheckedCities.push(childrenArray[i].tag_id) }
      } else {
        // 取消全选删除重复的id
        console.log('近')
        that.dialogCheckedCities = that.dialogCheckedCities.filter(item => !childrenArray.some(ele => ele.tag_id === item))
      }
    },
    onChangeSon(topIndex, sonId, topId, e) { // 子级change事件
      console.log('e', e)
      const that = this
      var childrenArray = that.cities[topIndex].children// 这里注意是选取一级下的二级数据
      var tickCount = 0
      var unTickCount = 0
      var len = childrenArray.length
      console.log(childrenArray)
      for (var i = 0; i < len; i++) {
        // eslint-disable-next-line eqeqeq
        if (sonId == childrenArray[i].tag_id) childrenArray[i].checked = e
        // eslint-disable-next-line eqeqeq
        if (childrenArray[i].checked == true) tickCount++
        // eslint-disable-next-line eqeqeq
        if (childrenArray[i].checked == false) unTickCount++
      }
      // eslint-disable-next-line eqeqeq
      if (tickCount == len) { // 子级全勾选
        that.cities[topIndex].checked = true
        that.cities[topIndex].indeterminate = false
      // eslint-disable-next-line eqeqeq
      } else if (unTickCount == len) { // 子级全不勾选
        that.cities[topIndex].checked = false
        that.cities[topIndex].indeterminate = false
      } else {
        that.cities[topIndex].checked = true
        that.cities[topIndex].indeterminate = true // 添加不确定状态
      }
    },
    arr1(arr) {
      return arr.filter(function(item, index, arr) {
        // 当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
        return arr.indexOf(item, 0) === index
      })
    },
    sumbit() {
      this.$emit('callback', this.arr1(this.dialogCheckedCities))
    },
    updata() {
      this.taglist()
      this.$emit('addlabel')
    },
    addlabel() {
      // this.$router.push({
      //   query: {
      //     id: this.corp_id
      //   },
      //   path: '/enterpriselabel/index'
      // })
      const routeUrl = this.$router.resolve({
        path: '/enterpriselabel/index',
        query: { id: this.corp_id }
      })
      window.open(routeUrl.href, '_blank')
      console.log('this.corp_id')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.updata_label{
  text-align: right;
  margin-bottom: 5px;

}
</style>
